import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dialog from '../Dialog';
import { Button, Alert } from 'react-bootstrap';
import EmailEditorForm from './EmailEditorForm';
import RemoteSubmitButton from '../formControls/RemoteSubmitButton';
import { withTranslation } from 'react-i18next';

class SendMessageDialog extends Component {
	constructor(props) {
		super(props);
		this.handleShowMoreLess = this.handleShowMoreLess.bind(this);
		this.handleFromCenterChange = this.handleFromCenterChange.bind(this);
		this.handleApplyTemplate = this.handleApplyTemplate.bind(this);
		this.state = {
			showAllRecipients: false,
			fromCenterId: null,
			appliedTemplateId: null
		};
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.centers && !this.state.fromCenterId) {
			const displayCenters = nextProps.centers && nextProps.centers.filter(c => !!c.email);
			if (displayCenters.length > 0) {
				const firstCenter = displayCenters[0];
				this.setState({ fromCenterId: firstCenter && firstCenter.id });
			}
		}
	}

	dialogConfig() {
		const { onCancel, t } = this.props;

		return {
			header: t('Parent_SendMessage_Title'),
			body: this.renderBody(),
			onHide: onCancel,
			footer: this.renderFooter()
		};
	}

	handleShowMoreLess() {
		this.setState({ showAllRecipients: !this.state.showAllRecipients })
	}

	handleFromCenterChange(fromCenterId) {
		this.setState({
			fromCenterId: Number(fromCenterId)
		});
	}

	handleApplyTemplate(templateId) {
		this.setState({
			appliedTemplateId: Number(templateId)
		});
	}

	getAppliedTemplate() {
		if (this.state.appliedTemplateId) {
			const { customTemplates } = this.props;
			return customTemplates.find(t => t.id === Number(this.state.appliedTemplateId));
		} else {
			const { centerTemplate, franchisorTemplate } = this.props;
			return this.state.fromCenterId === -1 ? franchisorTemplate : centerTemplate;
		}
	}

	renderBody() {
		const { onConfirm, to, centers, franchisor, customTemplates, selectedTemplateId, isRestrictedUser, tagCatalog, t } = this.props;
		if (to && to.length > 0) {
			const displayCenters = centers && centers.filter(c => !!c.email).map(c => ({ id: c.id, name: `${c.name} <${c.email}>` }))

			if (!isRestrictedUser) {
				displayCenters.push({ id: -1, name: `${franchisor.name} <${franchisor.systemEmail}>` })
			}
			const template = this.getAppliedTemplate();

			return <EmailEditorForm onSubmit={onConfirm} initialValues={{
				to,
				fromCenterId: this.state.fromCenterId,
				body: template && template.body,
				subject: template && template.subject,
				templateId: this.state.appliedTemplateId
			}}
				templates={customTemplates}
				templateId={selectedTemplateId}
				appliedTemplateId={this.state.appliedTemplateId}
				tagCatalog={tagCatalog}
				centers={displayCenters}
				showAllRecipients={this.state.showAllRecipients}
				onClickShowMoreLess={this.handleShowMoreLess}
				onFromCenterChange={this.handleFromCenterChange}
				onApplyTemplate={this.handleApplyTemplate}
			/>;
		}
		else
			return <Alert bsStyle='warning'>{t('SendMessage_NoRecipients')}</Alert>;
	}

	renderFooter() {
		const { onCancel, to, t } = this.props;

		const closeBtn = <Button key='close' onClick={onCancel}>{t('Common_Close')}</Button>;
		const confirmBtn = to && to.length > 0 && <RemoteSubmitButton key='email' style='primary' formName='sendMessage' label={t('Parent_SendMessage')} />;
		return [closeBtn, confirmBtn];
	}

	render() {
		const { show, block, unblock } = this.props;
		const dialogConfig = this.dialogConfig();
		return <Dialog config={dialogConfig} show={show} block={block} unblock={unblock} bsSize='large' enforceFocus={false} />;
	}
}

SendMessageDialog.propTypes = {
	show: PropTypes.bool,
	to: PropTypes.array,
	block: PropTypes.oneOfType([
		PropTypes.instanceOf(RegExp),
		PropTypes.string,
		PropTypes.array,
		PropTypes.func
	]),
	unblock: PropTypes.oneOfType([
		PropTypes.instanceOf(RegExp),
		PropTypes.string,
		PropTypes.array,
		PropTypes.func
	]),
	onCancel: PropTypes.func.isRequired,
	onConfirm: PropTypes.func.isRequired
};

export default withTranslation()(SendMessageDialog);